const teleportNavItems = (container) => {
  const navTarget = container.querySelector('.pdp-tabs__nav');
  const portals = container.querySelectorAll('.pdp-tabs__portal-nav [data-nav-portal]');
  
  if (!navTarget || portals.length === 0) return;
  
  portals.forEach(portalItem => {
    const tabId = portalItem.dataset.navPortal;
    // Check if it's already in the nav to avoid duplicates during section re-renders
    if (!navTarget.querySelector(`[data-tab="${tabId}"]`)) {
      navTarget.appendChild(portalItem);
    }
  });
};

const switchTab = (container, tab) => {
  if (!tab) return;
  
  const targetId = tab.dataset.tab;
  const newBg = tab.dataset.bg;
  const newText = tab.dataset.text;
  
  // Update CSS Variables on the section container
  container.style.setProperty('--active-bg', newBg);
  container.style.setProperty('--active-text', newText);
  
  const tabs = container.querySelectorAll('.pdp-tabs__nav-item');
  const contents = container.querySelectorAll('.pdp-tabs__content-item');
  
  tabs.forEach(t => {
    t.classList.remove('active');
    t.setAttribute('aria-selected', 'false');
  });
  
  contents.forEach(c => c.classList.remove('active'));

  tab.classList.add('active');
  tab.setAttribute('aria-selected', 'true');
  
  const targetContent = document.getElementById(targetId);
  if (targetContent) {
    targetContent.classList.add('active');
    // Important: Recalculate Glide on visible tab
    window.dispatchEvent(new Event('resize'));
  }
};

const initPdpTabs = () => {
  const containers = document.querySelectorAll('.pdp-tabs');
  
  containers.forEach(container => {
    // 1. Teleport items first
    teleportNavItems(container);

    const tabs = container.querySelectorAll('.pdp-tabs__nav-item');
    if (tabs.length > 0) {
      switchTab(container, tabs[0]);
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        switchTab(container, tab);
      });
    });

    // Initialize Glides
    const initGlides = () => {
      const glides = container.querySelectorAll('.glide');
      glides.forEach(glideNode => {
        const isGallery = glideNode.classList.contains('gallery-carousel');
        
        // Read dynamic settings from data attributes
        const perViewDesktop = parseInt(glideNode.dataset.perViewDesktop) || (isGallery ? 1 : 4);
        const perViewTablet = parseInt(glideNode.dataset.perViewTablet) || (isGallery ? 1 : 2);
        const perViewMobile = parseInt(glideNode.dataset.perViewMobile) || 1;

        const config = {
          type: 'carousel',
          gap: 16,
          perView: perViewDesktop,
          breakpoints: {
            // Synced with _variables.scss ($breakpoint-lg)
            1024: { perView: perViewTablet },
            // Synced with _variables.scss ($breakpoint-sm)
            640: { perView: perViewMobile }
          }
        };

        const glideInstance = new Glide(glideNode, config);
        glideInstance.mount();
      });
    };

    if (container.querySelector('.glide')) {
      if (typeof Glide === 'undefined') {
        // Load Glide Styles first if FH is available
        if (typeof FH !== 'undefined' && FH.loadStyle) {
          FH.loadStyle('https://cdn.jsdelivr.net/npm/@glidejs/glide/dist/css/glide.core.min.css');
        }

        // Load Glide Script via theme's loader
        if (typeof FH !== 'undefined' && FH.loadScript) {
          FH.loadScript({
            src: 'https://cdn.jsdelivr.net/npm/@glidejs/glide',
            asyncOrDefer: 'async',
            callback: () => {
              initGlides();
            }
          });
        } else {
          console.warn('FH.loadScript not found. Glide initialization failed.');
        }
      } else {
        initGlides();
      }
    }
  });
};

// Listen for Shopify Theme Editor events
document.addEventListener('shopify:block:select', (event) => {
  const blockId = event.detail.blockId;
  const sectionId = event.detail.sectionId;
  const container = document.querySelector(`.section-${sectionId}.pdp-tabs`);
  
  if (container) {
    // Re-teleport if necessary (though usually content_for 'blocks' handles it)
    teleportNavItems(container);

    const tabItem = container.querySelector(`[data-tab="tab-${blockId}"]`);
    if (tabItem) {
      switchTab(container, tabItem);
    }
  }
});

document.addEventListener('DOMContentLoaded', initPdpTabs);
export default initPdpTabs;
